import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import pluralize from 'pluralize';
class Translate extends Component {
  static propTypes = {
    translateKey: PropTypes.string,
    capitalize: PropTypes.any,
    plurals: PropTypes.any,
    id: PropTypes.any
  }

  static contextTypes = {
    t: PropTypes.func
  }

  buildTranslatedText = () => {
    const {t} = this.context;
    const {translateKey, capitalize, plurals, id = ''} = this.props;
    const isFirstCapitalize = capitalize ? 'first-capitalize' : '';
    const className = `translate-key translateKey-${translateKey} ${isFirstCapitalize}`;

    let translatedText = t ? t(translateKey) : translateKey;

    if (plurals) {
      translatedText = pluralize(translatedText);
    }

    return <span id={id} className={className}>{translatedText}</span>;
  }

  render() {
    return this.buildTranslatedText();
  }
}

const mapStateToProps = (state) => {
  return {
    i18nState: state.i18nState
  };
};

export default connect(mapStateToProps)(Translate);



// WEBPACK FOOTER //
// ./src/components/translate/index.js